import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

function Home() {
  return (
    <main className="bg-slate-950 text-slate-200">
      <Helmet>
        <title>Gabriel E. | Software Engineer</title>
      </Helmet>

      <div className="mx-auto flex min-h-[calc(100vh-9.5rem)] max-w-6xl flex-col justify-center px-6 py-16 md:px-12 md:py-20 lg:px-24">
        <section className="max-w-3xl">
          <p className="mb-5 text-sm font-medium uppercase tracking-[0.35em] text-cyan-400">
            Full-Stack Software Engineer
          </p>

          <h1 className="text-5xl font-bold tracking-tight text-slate-100 sm:text-6xl md:text-7xl">
            Gabriel E.
          </h1>

          <h2 className="mt-4 text-3xl font-semibold tracking-tight text-slate-400 sm:text-4xl">
            I build backend-heavy full-stack systems.
          </h2>

          <p className="mt-6 max-w-2xl text-lg leading-8 text-slate-400">
            I specialize in FastAPI, PostgreSQL, React, backend development,
            test automation, and internal engineering tools for network
            management and automation platforms.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-5">
            <Link
              to="/about"
              className="rounded border border-cyan-400 px-6 py-3 text-sm font-medium text-cyan-300 transition hover:bg-cyan-400/10 hover:text-cyan-200"
            >
              More About Me
            </Link>

            <Link
              to="/resume"
              className="text-sm font-medium text-slate-400 transition hover:text-cyan-300"
            >
              View Resume
            </Link>
          </div>

          <div className="mt-14 flex flex-wrap gap-3 text-sm text-slate-500">
            <span className="rounded-full border border-slate-700 px-4 py-2">
              FastAPI
            </span>
            <span className="rounded-full border border-slate-700 px-4 py-2">
              PostgreSQL
            </span>
            <span className="rounded-full border border-slate-700 px-4 py-2">
              React
            </span>
            <span className="rounded-full border border-slate-700 px-4 py-2">
              Test Automation
            </span>
            <span className="rounded-full border border-slate-700 px-4 py-2">
              CI/CD
            </span>
          </div>
        </section>
      </div>
    </main>
  );
}

export default Home;
